import type { Language } from '../config/siteContent'
import type { PricingValue as PricingValueConfig } from '../config/site'

type PricingValueProps = {
  language: Language
  value: PricingValueConfig
  className?: string
}

export default function PricingValue({ language, value, className = '' }: PricingValueProps) {
  const classes = `pricing-value ${className}`.trim()

  if (value.kind === 'custom') {
    return <span className={`${classes} pricing-value--text`}>{language === 'el' ? 'Εξατομικευμένη προσφορά' : 'Custom quote'}</span>
  }

  if (value.kind === 'assessment') {
    return <span className={`${classes} pricing-value--text`}>{language === 'el' ? 'Προσφορά μετά από αξιολόγηση' : 'Quote after assessment'}</span>
  }

  const formatter = new Intl.NumberFormat(language === 'el' ? 'el-GR' : 'en-IE', {
    style: 'currency', currency: 'EUR', maximumFractionDigits: 0,
  })
  const unit = value.unit === 'hour'
    ? (language === 'el' ? '/ώρα' : '/hour')
    : value.unit === 'track'
      ? (language === 'el' ? '/κομμάτι' : '/track')
      : ''

  return (
    <span className={classes}>
      {value.kind === 'from' && <small>{language === 'el' ? 'από' : 'from'}</small>}
      {formatter.format(value.amount)}
      {unit && <small>{unit}</small>}
    </span>
  )
}
